import React, { useState } from "react";
import { Check, Copy } from "lucide-react";

/* Copies `value` to the clipboard. The confirmation is a cross-fade in
   place of the button's own label — the idle label fades out as the
   confirmation fades in, then the reverse a moment later — rather than an
   abrupt swap. The confirmation matches whichever modality the button
   already is, not both at once (icon+text together read as congested in
   the tight icon-only slot, and a checkmark next to "Copied" was redundant
   noise next to an already-labelled "Clone" button): icon-only shows a
   plain green check in place of the copy glyph; the text button shows the
   word "Copied" alone, no icon. */
export function CopyButton({ value, label, iconOnly = false, size = 13, className = "" }) {
  const [copied, setCopied] = useState(false);

  if (!value) return null;

  const copy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      window.prompt("Copy this URL:", value);
      return;
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1400);
  };

  return (
    <button
      type="button"
      className={`Copy-Btn${iconOnly ? " icon-only" : ""}${copied ? " copied" : ""} ${className}`.trim()}
      onClick={copy}
      title={label || "Copy the clone URL"}
      aria-label={label || "Copy the clone URL"}
    >
      <span className="Copy-Btn-Idle">
        {iconOnly ? <Copy size={size} /> : "Clone"}
      </span>
      <span className="Copy-Btn-Done">
        {iconOnly ? <Check size={size} /> : "Copied"}
      </span>
    </button>
  );
}
